import React from 'react';
import {ImageType} from '../../../../types/Image';
import {Ratio} from '../../../atoms/Image/types';
import {ContentBlockImageTile} from '../ContentBlockImageTile/ContentBlockImageTile';
import {
  ContentBlockVideo,
  VideoType,
} from '../ContentBlockVideo/ContentBlockVideo';

export interface ContentBlockMediaProps {
  className?: string;
  testId?: string;
  imageOrVideo:
    | {
        $case: 'image';
        image: ImageType & {aspectRatio: Ratio};
      }
    | {
        $case: 'video';
        video: VideoType;
      };
  videoRef: React.RefObject<HTMLVideoElement | null>;
  onEndVideoCallback?: VoidFunction;
}

export const ContentBlockMedia: React.FC<ContentBlockMediaProps> = ({
  className,
  imageOrVideo,
  testId = 'ContentBlockMedia',
  videoRef,
  onEndVideoCallback,
}) => {
  if (!imageOrVideo) return null;

  if (imageOrVideo?.$case === 'video') {
    return (
      <ContentBlockVideo
        className={className}
        video={imageOrVideo.video}
        testId={`${testId}VideoTile`}
        videoRef={videoRef}
        onEndVideoCallback={onEndVideoCallback}
      />
    );
  }

  return (
    <ContentBlockImageTile
      className={className}
      image={imageOrVideo.image}
      testId={`${testId}ImageTile`}
    />
  );
};
